import { useEffect, useState } from "react";

import {
  ResearchApiPost,
  fetchResearchPostById,
} from "../services/researchService";

export const useResearchPostDetail = (id?: string) => {
  const [post, setPost] = useState<ResearchApiPost | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) {
      setPost(null);
      return;
    }

    let isMounted = true;
    setLoading(true);
    setError(null);

    const loadPost = async () => {
      try {
        const data = await fetchResearchPostById(id);
        if (isMounted) {
          setPost(data);
        }
      } catch (err) {
        if (isMounted) {
          setError(
            err instanceof Error ? err.message : "Failed to load research post"
          );
          setPost(null);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadPost();

    return () => {
      isMounted = false;
    };
  }, [id]);

  return { post, loading, error };
};

